import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggleable", "collapsible"];

  toggle() {
    this.toggleableTargets.forEach((target) => {
      target.classList.toggle("hidden");
    });
    this.collapsibleTargets.forEach((target) => {
      target.open = false;
    });
  }
}
